<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
      <el-collapse-transition>
        <div class="search-content common-search-formtype" style="line-height: 48px;border: none">
          <div class="demo-input-suffix" style="text-align: left;margin-left: 32px">
            公众号切换：
            <el-select @change="searchData" v-model="formInlineTmp.public_id" placeholder="请选择">
              <el-option
                v-for="item in weChatOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="输入搜索：">
              <el-input @keyup.enter.native="searchData" v-model.trim="formInlineTmp.keywords" placeholder="请输入姓名/手机号" clearable ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="bindWechatAction" class="add-btn btn-right" style="float: right;">微信绑定</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="bindWechatAction">新建</span></div>
        </template>
        <el-table-column
          label="业务员"
          min-width="120">
          <template slot-scope="scope">
            <img :src="scope.row.avatar" style="width: 40px;display: block;margin: 0 auto;border-radius: 50%;float:left;margin-right:10px;">
            <div style="line-height: 32px;">{{ scope.row.nickname }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="realname"
          label="姓名">
        </el-table-column>
        <!-- <el-table-column
          label="公众号">
           <template slot-scope="scope">
            {{ publicList[scope.row.public_id] }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="department"
          label="部门">
          <!-- <template slot-scope="scope">
            <div v-if="scope.row.structure_name === null || scope.row.structure_name === ''">无</div>
            <div v-if="scope.row.structure_name !== null">{{ scope.row.structure_name }}</div>
          </template> -->
        </el-table-column>
        <el-table-column
          width="110"
          prop="mobile"
          label="手机号">
        </el-table-column>
        <el-table-column
          label="创建时间"
          width='135'>
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link editColor" @click="editAction(scope.row)">
              编辑
            </div>
            <div class="op-link deleteColor" @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 二维码 -->
      <el-dialog class="cellDialog base-dialog" title="二维码" :visible.sync="QRViewDialog" width="520px">
        <div style="margin: 10px 0 30px 0;text-align: left;">
          <span style="display: block;width: 240px;margin:0 auto;">公众号：{{ publicList[formInlineTmp.public_id] }}</span>
        </div>
        <!-- <el-form :inline="true" class="" label-width="60px" style="margin-right: 10">
          <el-form-item label="公众号:">
            <el-select v-model="qrCodeId" disabled placeholder="请选择" @change="changeQRCodeAction" style="width: 320px;">
              <el-option
                v-for="item in weChatPublic"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form> -->
        <qriously :value="qrCodeUrl" :size="240" />
      </el-dialog>
       <!-- 二维码 -->
      <el-dialog class="cellDialog base-dialog" title="编辑业务员信息" :visible.sync="editDialog" width="520px">
        <el-form :model="editForm" label-width="80px" ref="editForm" :rules="rules">
          <el-form-item label="姓名：" prop="realname">
            <el-input v-model="editForm.realname" placeholder="请输入姓名" ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="editForm.mobile" placeholder="请输入手机号" type=""></el-input>
          </el-form-item>
          <el-form-item label="部门：" prop="department">
            <el-input v-model="editForm.department" placeholder="请输入部门" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="editDialog = false">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('editForm')">确 定</el-button>
        </div>
      </el-dialog>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getSalesmanList, getWechatPublicListForNode, editSalesman, getDepartment, deleteSalesman, getSalesmanDetails } from '@/api/customer.js'
import { API_HOST } from '@/api/local'
export default {
  name: 'salesmanList',
  data () {
    return {
      weChatPublics: [],
      loading: true,
      editForm: {},
      editDialog: false,
      QRViewDialog: false,
      weChatOptions: [],
      addGradeForm: {
        grade: '',
        grade_list: []
      },
      addGradeDialog: false,
      formInlineTmp: {
        public_id: '',
        keywords: ''
      },
      formInline: {
        keywords: '',
        public_id: ''
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      inGradeList: [],
      isSwitchClick: 1,
      // 会员等级
      memberLevelList: {},
      weChatPublic: [],
      rules: {
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请选择部门', trigger: 'blur' }
        ]
      },
      structureOptions: [],
      salesmanId: '',
      publicList: {}
    }
  },
  mounted () {
    rule.publicNumber((res) => {
      for (let item of res.data.data.list) {
        // if (item.is_disable === 0) {
        //   this.publicNumber.push(item)
        // }
        if (item.is_default === 1) {
          this.formInlineTmp.public_id = item.id
          // this.original_id = item.original_id
        }
      }
    })
  },
  computed: {
    qrCodeUrl() {
      return API_HOST + 'weixinmobile/Salesman/bindWechat?public_id=' + this.formInlineTmp.public_id
    }
  },
  methods: {
    searchData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    bindWechatAction() {
      this.QRViewDialog = true
    },
    bindSalesmanWechat () {
      bindSalesman(this.formInline.public_id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    editAction(item) {
      this.salesmanId = item.id
      this.loadSalesmanDetails()
      this.editDialog = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formInline.mobile !== '') {
            let mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/
            if (!mobile.test(this.editForm.mobile)) {
              _g.toastMsg('error', '请填入正确手机号')
              return
            }
          }
          this.editSalesmanAction()
        } else {
          return false
        }
      })
    },
    deleteAction(id) {
      this.$confirm('确认删除该业务员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSalesman(id).then(res => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      })
    },
    // 获取部门
    getAllOrgs() {
      getDepartment(1).then((res) => {
        if (res.data.code === 0) {
          this.structureOptions = res.data.data.list
        }
      })
    },
    editSalesmanAction() {
      editSalesman(this.editForm, this.salesmanId).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.editDialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    loadSalesmanDetails() {
      let _this = this
      getSalesmanDetails(this.salesmanId).then(res => {
        let flag = 0
        this.structureOptions.some(item => {
          if (item.id !== res.data.data.structure_id) {
            flag++
          }
          if (flag === this.structureOptions.length) {
            _this.structureOptions.push({
              id: res.data.data.structure_id,
              name: '无'
            })
          }
        })
        this.editForm = res.data.data
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    loadWechatList() {
      getWechatPublicListForNode('1').then(res => {
        for (let item of res.data.data.list) {
          this.weChatOptions.push({
            id: item.id,
            name: item.nick_name
          })
          this.publicList[item.id] = item.nick_name
          if (item.is_default === 1) {
            this.formInlineTmp.public_id = item.id
            this.formInline.public_id = item.id
          }
          this.weChatPublic.push({
            id: item.id,
            name: item.nick_name
          })
        }
        this.getData()
      })
    },
    getData() {
      this.loading = true
      getSalesmanList(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.total
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.loadWechatList()
    this.getAllOrgs()
  },
  components: {
  }
}
</script>

<style scoped>
.structure .el-select {
  width: 300px;
}
</style>
